import envConfig from '@hulu/env-config';

export const openCreativeStudio = (): void => {
  window.open(envConfig.REACT_APP_GENIE_REDIRECT_LINK, '_blank', 'noopener,noreferrer');
};
